import { render, staticRenderFns } from "./EventCardList.vue?vue&type=template&id=6bc77a2e&scoped=true&"
import script from "./EventCardList.vue?vue&type=script&lang=ts&"
export * from "./EventCardList.vue?vue&type=script&lang=ts&"
import style0 from "./EventCardList.vue?vue&type=style&index=0&id=6bc77a2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc77a2e",
  null
  
)

export default component.exports